import { render } from "./ActiveDangersCard.vue?vue&type=template&id=cfb1d502&scoped=true"
import script from "./ActiveDangersCard.vue?vue&type=script&lang=js"
export * from "./ActiveDangersCard.vue?vue&type=script&lang=js"

import "./ActiveDangersCard.vue?vue&type=style&index=0&id=cfb1d502&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb1d502"]])

export default __exports__